import { useState } from "react";
import { getFileList } from "../../../store/actions/orderActionCreators";
import { getUserFromStorage } from "../../../util/localStorage.util";
import { SelectedOrder } from "../OrderPage.types";

const storageInfo = getUserFromStorage();

function getAuthHeader(url: any) {
  if (url.blobFile) return undefined;
  return {
    headers: {
      Authorization: `Bearer ${
        storageInfo ? JSON.parse(storageInfo).data.token : ""
      }`,
    },
  };
}

export function useFileModal() {
  const [fileModal, setFileModal] = useState<boolean>(false);
  const [fileList, setFileList] = useState<any[]>([]);
  const [fileLoading, setFileLoading] = useState<boolean>(false);
  const [downloadLoading, setDownloadLoading] = useState<boolean>(false);
  const [selectedOrder, setSelectedOrder] = useState<SelectedOrder | undefined>();

  const openFileModal = async (file: any) => {
    setFileLoading(true);
    setSelectedOrder(file);
    const [response, err]: Array<any> = await getFileList(file.soNo);
    if (response) {
      setFileList(
        response.map((f: any, Key: any) => ({
          sn: f.sn,
          key: Key,
          fileName: f.fileName,
          description: f.description,
          file: f,
        }))
      );
    } else {
      setFileList([]);
    }
    if (err) setFileList([]);
    setFileLoading(false);
    setFileModal(true);
  };

  const closeFileModal = () => setFileModal(false);

  const viewFile = (url: any) => {
    setFileLoading(true);
    fetch(url.link, getAuthHeader(url))
      .then((res: any) => res.blob())
      .then((res: any) => {
        window.open(window.URL.createObjectURL(res));
        setFileLoading(false);
      });
  };

  const downloadFile = (file: any) => {
    setDownloadLoading(true);
    fetch(file.link, getAuthHeader(file))
      .then((res: any) => res.blob())
      .then((res: any) => {
        const link = window.URL.createObjectURL(res);
        const a = document.createElement("a");
        a.href = link;
        a.download = file.fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setDownloadLoading(false);
      });
  };

  return {
    fileModal,
    fileList,
    fileLoading,
    downloadLoading,
    selectedOrder,
    openFileModal,
    closeFileModal,
    viewFile,
    downloadFile,
  };
}
